import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import TagLink from "../components/tagLink"

const StaticTagList = ({ tagType, headingText, className }) => {
  const data = useStaticQuery(
    graphql`
      query tagQuery {
        allMarkdownRemark(
          limit: 2000
          filter: { fields: { meta: { draft: { eq: false } } } }
        ) {
          group(field: frontmatter___tags) {
            fieldValue
          }
        }
        categoryTags: allTagsJson(
          filter: { type: { eq: "category" } }
          sort: { fields: priority, order: ASC }
        ) {
          nodes {
            name
            title
          }
        }
        assignmentTags: allTagsJson(
          filter: { type: { eq: "assignment" } }
          sort: { fields: priority, order: ASC }
        ) {
          nodes {
            name
            title
          }
        }
        marketingMeasuresTags: allTagsJson(
          filter: { type: { eq: "marketing-measures" } }
          sort: { fields: priority, order: ASC }
        ) {
          nodes {
            name
            title
          }
        }
        toolsChannelTags: allTagsJson(
          filter: { type: { eq: "tools-channel" } }
          sort: { fields: priority, order: ASC }
        ) {
          nodes {
            name
            title
          }
        }
        industryTags: allTagsJson(
          filter: { type: { eq: "industry" } }
          sort: { fields: priority, order: ASC }
        ) {
          nodes {
            name
            title
          }
        }
        allTagTypeJson {
          nodes {
            name
            title
          }
        }
      }
    `
  )

  const allUsedTags = data.allMarkdownRemark.group
  const filterUsedTag = tagList => {
    return tagList.filter(obj => {
      return !!allUsedTags.find(tag => tag.fieldValue === obj.name)
    })
  }

  const findTagTypeTitle = tagTypeName => {
    const tagTypeMetaData = data.allTagTypeJson.nodes.find(
      obj => obj.name === tagTypeName
    )
    return tagTypeMetaData.title
  }

  let filteredTag = []

  switch (tagType) {
    case "category":
      filteredTag = filterUsedTag(data.categoryTags.nodes)
      break
    case "assignment":
      filteredTag = filterUsedTag(data.assignmentTags.nodes)
      break
    case "marketing-measures":
      filteredTag = filterUsedTag(data.marketingMeasuresTags.nodes)
      break
    case "tools-channel":
      filteredTag = filterUsedTag(data.toolsChannelTags.nodes)
      break
    case "industry":
      filteredTag = filterUsedTag(data.industryTags.nodes)
      break
    default:
      return
  }

  if (filteredTag.length === 0) return null

  return (
    <div className={className}>
      <h3 className="text-textGray-100 w-full flex gap-1 lg:gap-3 items-center font-bold text-base lg:text-xl tracking-wide mb-4 lg:mb-6 after:block after:h-px after:flex-grow after:bg-brandGray">
        {findTagTypeTitle(tagType)}{headingText ? headingText : "から探す"}
      </h3>
      <div className="flex flex-wrap flex-gap-2 pb-5 lg:pb-7">
        {filteredTag.map(tag => (
          <TagLink
            name={tag.name}
            title={tag.title}
            key={`tag-list-${tag.name}`}
            size={"l"}
          />
        ))}
      </div>
    </div>
  )
}

StaticTagList.propTypes = {
  tagType: PropTypes.oneOf([
    "category",
    "assignment",
    "marketing-measures",
    "tools-channel",
    "industry",
  ]),
  headingText: PropTypes.string,
  className: PropTypes.string,
}

export default StaticTagList
